import { render } from "./Board.vue?vue&type=template&id=7aa7bf04&scoped=true"
import script from "./Board.vue?vue&type=script&lang=js"
export * from "./Board.vue?vue&type=script&lang=js"

import "./Board.vue?vue&type=style&index=0&id=7aa7bf04&scoped=true&lang=css"

import exportComponent from "/home/drdilyor/workspace/minesweeper/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aa7bf04"]])

export default __exports__